import { Search } from "lucide-react"

import { AdditionalDocumentsSelectionOverlay } from "@/components/overlays/AdditionalDocumentsSelectionOverlay"
import { Button } from "@ui/button"

import { ContentObjectItem } from "@vertesia/common"

interface ReportAdditionalDocumentSelectionProps {
    more?: boolean
    handleDocumentSelection: (documents: ContentObjectItem[]) => void
}
export function ReportAdditionalDocumentSelection({ more = false, handleDocumentSelection }: Readonly<ReportAdditionalDocumentSelectionProps>) {
    return (
        <AdditionalDocumentsSelectionOverlay onObjMultipleSelection={handleDocumentSelection}>
            <Button>
                <Search />
                { 
                    (more) ? (
                        "Add More"
                    ) : (
                        "Search Documents"
                    )
                }
            </Button>
        </AdditionalDocumentsSelectionOverlay>
    )
}
